<p class="mt-4 mb-2">
  Всего: <b>{{count}}</b>
</p>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (!el.input && el.name !== 'search_fields') {
                    {{el.caption}}
                  }
                  @if (el.name === 'search_fields') {
                    <app-material-select2 [noCopy]="false" [placeholder]="'Все объекты'" [multiple]="true" formControlName="search_fields">
                      <option [value]="'cian'">Не выбрана Cian новостройка</option>
                      <option [value]="'cian_housing'">Не выбран Cian корпус</option>
                      <option [value]="'yandex'">Не выбрана Yandex новостройка</option>
                      <option [value]="'yandex_housing'">Не выбран Yandex корпус</option>
                      <option [value]="'avito'">Не выбрана Avito новостройка</option>
                      <option [value]="'avito_housing'">Не выбран Avito корпус</option>
                    </app-material-select2>
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      <!-- // -->
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>
            @if (row['complex_id']) {
              <a class="d-block mb-2" href="/housing2/complex/{{row['complex_id']}}"
                (click)="goBack.newLink('/housing2/complex/' + row['complex_id'], 'complex_caption' + row_index, $event)">
                {{row['complex_caption']}}
              </a>
            }
          </td>
          <td>
            @if (row['ids'].length) {
              @for (el of row['ids']; track el; let row_index = $index) {
                @if (el[0]) {
                  <a class="d-block mb-2" href="/housing2/house/{{el[0]}}"
                    (click)="goBack.newLink('/housing2/house/' + el[0], 'house_caption' + row_index, $event)">
                    {{el[1]}}
                  </a>
                }
              }
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>
<div class="alt-pagination">
  <app-paginator
    [queryParams]="filter_columns"
    [itemsPerPage]="50"
    [itemCount]="count"
    [currentPage]="current_page"
    [baseUrl]="'/cian-yandex'">
  </app-paginator>
</div>
